import { render, staticRenderFns } from "./BalancesPlansTable.vue?vue&type=template&id=3a4c1c62&"
import script from "./BalancesPlansTable.vue?vue&type=script&lang=js&"
export * from "./BalancesPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports